import { render, staticRenderFns } from "./LearningRecord.vue?vue&type=template&id=3ba2521e&scoped=true&"
import script from "./LearningRecord.vue?vue&type=script&lang=js&"
export * from "./LearningRecord.vue?vue&type=script&lang=js&"
import style0 from "./LearningRecord.vue?vue&type=style&index=0&id=3ba2521e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba2521e",
  null
  
)

export default component.exports